const T_PREFIX = "watchlist";

export const watchlistTrns = {
  title: `${T_PREFIX}.title`,
};

export const noWatchlistBannerTrns = {
  title: `${T_PREFIX}.no-watchlist-banner.title`,
  description: `${T_PREFIX}.no-watchlist-banner.description`,
  addInquiryToWatchlistButton: `${T_PREFIX}.no-watchlist-banner.add-inquiry-to-watchlist-btn`,
};
